import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import { AngularFireAuth } from 'angularfire2/auth';
import { DocumentReference } from 'angularfire2/firestore';
import firebase from 'firebase';
import 'firebase/firestore';
/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
export interface User {
  uid: string;
  email: string;
  photoURL?: string;
  displayName?: string;
  phoneNumber?: string;
}

@Injectable()
export class AuthProvider {
  user: Observable<User>;
  constructor(public http: HttpClient, private afAuth: AngularFireAuth) {
    this.user = this.afAuth.authState
      .map(user => {
        return user;
      });
    firebase.firestore().settings({ timestampsInSnapshots: true });
  }

  public async updateUserData(user) {
    // Sets user data to firestore on login
    let data;
    const userRef: DocumentReference = await firebase.firestore().doc(`users/${user.uid}`);
    data = {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      phoneNumber: user.phoneNumber
    }
    return userRef.set(data, { merge: true });

  }

  public getUser(): Observable<User> {
    return this.user;
  }

  public async didUserResponded(uid:string): Promise<boolean> {
    const docSnapShot = await firebase.firestore().doc(`surveys/${uid}`).get();
    return Promise.resolve(docSnapShot.exists);

  }

  logout() {
    this.user = null;
    return this.afAuth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts